import { useSyncExternalStore } from 'react';

const subscribe = (cb: () => void) => {
  window.addEventListener('resize', cb);
  return () => window.removeEventListener('resize', cb);
};

const getSnapshot = () => window.innerWidth;

const getServerSnapshot = () => 0;

const useWindowWidth = () =>
  useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);

export default useWindowWidth;
